import { parseJsonField } from "../../utils/parseJsonField";
import "../../css/pageLayout.css"

function QuoteSection({ section }) {
  const settings = parseJsonField(section.settings_json);

  return (
    <section className="quote-section">
      {settings.quote_text && (
        <blockquote>
          “{settings.quote_text}”
        </blockquote>
      )}

      {settings.author && <p className="quote-author">— {settings.author}</p>}
    </section>
  );
}

export default QuoteSection;